<section class="certificate-traceability">
    <p class="error-message" *ngIf="showNoTraceabilityText">{{'trazabilidad-certificado.error.carga' | translate}}</p>

    <ng-container *ngIf="certificateTraceability">
        <figure class="logo">
        <img src="assets/img/logos/Logo_Gesvatec_PackCert.png" alt="Gesvatec">
        </figure>
        <div class="title-group">
            <h1 id="certificate-traceability-title">{{  title }}</h1>
            <p>{{ 'trazabilidad-certificado.informe.certificado' | translate }}: {{ certificateTraceability.nCertificadoExpedicion }}</p>
        </div>

        <app-stepper 
            [steps]="steps" [iconsClassName]="icons" [allActive]="true"
            [heightToAdd]="blockchainInfoHeight" [sectionPosition]="parentPosition" [accordionAction]="blockchainAction">
            <!-- Cultivos -->
            <div data-step="1">
                <div class="data-group">
                    <p>{{ 'global.producto' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoCultivos_Producto }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'global.denominacion' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoCultivos_Denominacion }}</p>
                </div>

                <div class="table-wrapper table-wrapper-traza-cert">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="icon"></th>
                                    <th class="string">{{ 'global.codigoCultivo' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.provincia' | translate }}</th>
                                    <th class="string">{{ 'global.pais' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let cultivo of certificateTraceability.procesoCultivos; let i=index">
                                <tr>
                                    <td class="icon"></td>
                                    <td class="string">{{ cultivo.codigoCultivo }}</td>
                                    <td class="string">{{ cultivo.finca }}</td>
                                    <td class="string">{{ cultivo.municipio }}</td>
                                    <td class="string">{{ cultivo.provincia }}</td>
                                    <td class="string">{{ cultivo.pais }}</td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!certificateTraceability.procesoCultivos || 
                                (certificateTraceability.procesoCultivos && certificateTraceability.procesoCultivos.length < 1)">
                                <tr>
                                    <td colspan="6">
                                        {{'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Designaciones -->
            <div data-step="2">
                <div class="table-wrapper table-wrapper-traza-cert" style="margin-top: unset;">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="icon"></th>
                                    <th class="date">{{ 'global.fecha.designacion' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.etiquetador' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let designacion of certificateTraceability.procesoDesignaciones; let i=index">
                                <tr>
                                    <td class="icon"></td>
                                    <td class="date">{{ designacion.fechaDesignacion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                    <td class="string">{{ designacion.finca }}</td>
                                    <td class="string">{{ designacion.municipio }}</td>
                                    <td class="string">{{ designacion.etiquetador }}</td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!certificateTraceability.procesoDesignaciones || 
                                (certificateTraceability.procesoDesignaciones && certificateTraceability.procesoDesignaciones.length < 1)">
                                <tr>
                                    <td colspan="5">
                                        {{'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Confecciones -->
            <div data-step="3">
                <div class="data-group">
                    <p>{{ 'trazabilidad-certificado.informe.almacen' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoConfeccion_AlmacenEnvasado }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidad-certificado.informe.direccionAlmacen' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoConfeccion_AlmacenDireccion }}</p>
                </div>

                <div class="table-wrapper table-wrapper-traza-cert">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="icon"></th>
                                    <th class="date">{{ 'global.fecha.confeccion' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.confeccion' | translate }}</th>
                                    <th class="string">{{ 'global.type' | translate }}</th>
                                    <th class="number">{{ 'global.unidades' | translate }}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let confeccion of certificateTraceability.procesoConfeccion; let i=index">
                                <tr>
                                    <td class="icon"></td>
                                    <td class="date">{{ confeccion.fechaConfeccion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                                    <td class="string">{{ confeccion.finca }}</td>
                                    <td class="string">{{ confeccion.municipio }}</td>
                                    <td class="string">{{ confeccion.confeccion }}</td>
                                    <td class="string">{{ confeccion.tipo === 1 ? ('global.caja' | translate) :
                                        confeccion.tipo === 2 ? ('global.pallet' | translate) : '' }}</td>
                                    <td class="number">{{ confeccion.unidades | number : '1.0-0' : defaultLanguage }}</td>
                                    <td class="icon"></td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!certificateTraceability.procesoConfeccion || 
                                (certificateTraceability.procesoConfeccion && certificateTraceability.procesoConfeccion.length < 1)">
                                <tr>
                                    <td colspan="8">
                                        {{'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Expediciones -->
            <div data-step="4">
                <div class="data-group">
                    <p>{{ 'global.fecha.expedicion' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoExpediciones_FechaExpedicion | date: 'shortDate' : undefined : defaultLanguage }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidad-certificado.informe.paisOrigen' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoExpediciones_Pais }}</p>
                </div>
                <div class="data-group">
                    <p>{{ 'trazabilidad-certificado.informe.cajasTotal' | translate }}:</p>
                    <p>{{ certificateTraceability.procesoExpediciones_TotalCajas | number : '1.0-0' : defaultLanguage }}</p>
                </div>

                <div class="table-wrapper table-wrapper-traza-cert">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th class="icon"></th>
                                    <th class="string">{{ 'global.lote' | translate }}</th>
                                    <th class="string">{{ 'global.finca' | translate }}</th>
                                    <th class="string">{{ 'global.municipio' | translate }}</th>
                                    <th class="string">{{ 'global.provincia' | translate }}</th>
                                    <th class="number">{{ 'global.cajas' | translate }}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let expedicion of certificateTraceability.procesoExpediciones; let i=index">
                                <tr>
                                    <td class="icon"></td>
                                    <td class="string">{{ expedicion.lote }}</td>
                                    <td class="string">{{ expedicion.finca }}</td>
                                    <td class="string">{{ expedicion.municipio }}</td>
                                    <td class="string">{{ expedicion.provincia }}</td>
                                    <td class="number">{{ expedicion.cajas | number : '1.0-0' : defaultLanguage }}</td>
                                    <td class="icon"></td>
                                </tr>
                            </tbody>
                            <tfoot *ngIf="!certificateTraceability.procesoExpediciones || 
                                (certificateTraceability.procesoExpediciones && certificateTraceability.procesoExpediciones.length < 1)">
                                <tr>
                                    <td colspan="7">
                                        {{ 'global.noContent' | translate }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                <!-- Desplegable blockchain -->
                <div *ngIf="certificateTraceability?.certificadoExpedicionVechain?.existeRegBlockchain" class="blockchain-container blockchain-container-expediciones collapsed">
                    <div class="blockchain-title blockchain-title-expediciones" (click)="showOrHideData(3, 'expediciones')">
                        <i class="fas fa-circle-nodes"></i>
                        <h3>{{'global.blockchain.verRastreo' | translate}}</h3>
                        <i class="fas fa-angle-down blockchain-arrow blockchain-arrow-expediciones"></i>
                    </div>
                    <div class="blockchain-content blockchain-content-expediciones">
                        <div class="data-blockchain link">
                            <p>{{'global.blockchain.informacion.blockchain' | translate}}</p>
                            <span>
                                {{ certificateTraceability?.certificadoExpedicionVechain?.blockchain }}
                                <a
                                    [href]="getBlockchainLink(certificateTraceability?.certificadoExpedicionVechain?.txId)" target="_blank">
                                        ({{'global.blockchain.informacion.enlace' | translate}})</a>
                            </span>
                        </div>
                        <div class="data-blockchain">
                            <p>{{'global.blockchain.informacion.fechaRegistro' | translate}}</p>
                            <p>{{ certificateTraceability?.certificadoExpedicionVechain?.fechaRegistro | date: 'shortDate' : undefined : defaultLanguage }}</p>
                        </div>
                        <div class="data-blockchain">
                            <p>{{ 'global.blockchain.informacion.input' | translate}}</p>
                            <p>{{ certificateTraceability?.certificadoExpedicionVechain?.textoHash }}</p>
                        </div>
                        <div class="data-blockchain">
                            <p>{{'global.blockchain.informacion.hash' | translate}}</p>
                            <p>{{ certificateTraceability?.certificadoExpedicionVechain?.hash }}</p>
                        </div>
                        <div class="data-blockchain">
                            <p>{{'global.blockchain.informacion.idCripto' | translate}}</p>
                            <p>{{ certificateTraceability?.certificadoExpedicionVechain?.txId }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </app-stepper>
    </ng-container>

    <app-spinner *ngIf="showSpinner"></app-spinner>
</section>